import { render } from "./course-four.vue?vue&type=template&id=dfa42740"
import script from "./course-four.vue?vue&type=script&lang=js"
export * from "./course-four.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__